import React, { ReactNode } from "react";
import { useMediaQuery } from "../../hooks/useMediaQuery";

interface ChatLayoutProps {
  messagesContent: ReactNode;
  inputContent: ReactNode;
  hasMessages: boolean;
  darkTheme?: boolean;
}

/**
 * ChatLayout - Gère UNIQUEMENT le layout interne du chat
 *
 * Responsabilités :
 * - Conteneur de messages avec scroll
 * - Positionnement du chat input (sticky bottom)
 * - Centrage du message d'accueil quand pas de messages
 * - Padding pour éviter que les messages soient cachés
 *
 * NE gère PAS :
 * - La logique métier (IA, envoi messages, etc.)
 * - Le contenu des messages
 * - Le contenu de l'input
 */
export function ChatLayout({
  messagesContent,
  inputContent,
  hasMessages,
  darkTheme = false,
}: ChatLayoutProps) {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isTablet = useMediaQuery("(min-width: 769px) and (max-width: 1023px)");
  const isMobileOrTablet = isMobile || isTablet;

  return (
    <div className="flex flex-col flex-1 min-h-0">
      {/* Zone de messages avec scroll */}
      <div
        className={`flex-1 overflow-y-auto ${!hasMessages ? "grid place-items-center" : ""}`}
      >
        <div
          className={`${!hasMessages ? "w-full" : "flex flex-col space-y-6 p-6"}`}
        >
          {messagesContent}
        </div>
      </div>

      {/* Zone de saisie - Flex shrink-0 pour rester en bas */}
      <div
        className={`flex-shrink-0
            ${isMobile ? "p-3" : "p-3"}
            border-border
            `}
      >
        {inputContent}
      </div>
    </div>
  );
}
